import React, { useContext, useEffect, useRef } from 'react';
import { IoIosCloseCircleOutline } from 'react-icons/io';

import { AppContext } from 'src/containers/Core/AppContext';
import { setLeftMenuVisibility } from 'src/containers/Core/AppReducer';
import { AppViewContext } from 'src/containers/Core/AppView';
import BusinessOnboardingSteps from '../BusinessOnboarding/BusinessOnboardingSteps';
import Logout from './Logout';
import UserCard from './UserCard';

import './style.scss';

const LeftMenu: React.FunctionComponent = () => {
  const menuRef = useRef(null);
  const { isPhoneView } = useContext(AppViewContext);
  const { store, dispatch } = useContext(AppContext);
  const { leftMenuVisibility } = store;

  const leftMenuClass = `${
    leftMenuVisibility ? 'd-flex flex-column mobile-left-menu' : 'd-none'
  } nav-left-menu position-fixed overflow-hidden`;

  useEffect(() => {
    document.addEventListener('click', handleClick, false);

    return () => {
      document.removeEventListener('click', handleClick, false);
    };
  }, [leftMenuVisibility]);

  //tslint:disable-next-line:no-any
  const handleClick = (event: any) => {
    const profileContextMenu = document.getElementById('profile-options-context-menu');
    if (menuRef && menuRef.current && !menuRef.current.contains(event.target) && leftMenuVisibility) {
      if (profileContextMenu && profileContextMenu.contains(event.target)) {
        return;
      }
      dispatch(setLeftMenuVisibility(false));
    }
  };

  const renderLeftMenu = () => {
    if (!isPhoneView || (isPhoneView && leftMenuVisibility)) {
      return (
        <>
          <div className="d-flex left-menu-header p-2 align-items-center">
            <UserCard />

            {isPhoneView ? (
              <IoIosCloseCircleOutline
                size={24}
                className="c-pointer ml-1"
                onClick={() => {
                  setLeftMenuVisibility(false);
                }}
              />
            ) : null}
          </div>
          {/* <NavigationOptions /> */}
          <BusinessOnboardingSteps />
          <Logout />
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className={`leftmenu h-100 pb-3 border-right ${
        isPhoneView ? leftMenuClass : 'd-flex flex-column position-relative'
      } `}
      ref={menuRef}
    >
      {renderLeftMenu()}
      <small className="text-muted float-right position-absolute px-2" style={{ bottom: isPhoneView ? '5px' : 0 }}>
        v{process.env.REACT_APP_VERSION}
      </small>
    </div>
  );
};

export default LeftMenu;
